import React, { useCallback } from 'react';
import { PiPencilSimple, PiEyeClosed } from 'react-icons/pi';
import { useLayers } from '@ais-ui/react-openlayers';
import { usePermissions } from '../../Permissions/PermissionsProvider';
import { useMapContextMenu, PortAdminFeature } from './MapContextMenuContext';
import { MenuItem } from './MenuItem';
import {
  PORT_ADMIN_LAYER_PREFIX,
  PORT_ADMIN_INNER_LAYER_PREFIX,
} from '../../PortAdmin/ShowHidePortButton';

interface PortAdminContextMenuItemsProps {
  port: PortAdminFeature['data'];
}

export const PortAdminContextMenuItems = ({
  port,
}: PortAdminContextMenuItemsProps) => {
  const permissions = usePermissions();
  const { removeLayerById } = useLayers();
  const { closeContextMenu, openEditPortDialog } = useMapContextMenu();

  const onEdit = useCallback(() => {
    openEditPortDialog(port.portId);
    closeContextMenu();
  }, [openEditPortDialog, port.portId, closeContextMenu]);

  const onHide = useCallback(() => {
    removeLayerById(`${PORT_ADMIN_LAYER_PREFIX}${port.portId}`);
    removeLayerById(`${PORT_ADMIN_INNER_LAYER_PREFIX}${port.portId}`);
    closeContextMenu();
  }, [removeLayerById, port.portId, closeContextMenu]);

  return (
    <>
      <MenuItem disabled={!permissions.portAdmin} onClick={onEdit}>
        <PiPencilSimple className="h-4 w-4" />
        Edit Port
      </MenuItem>

      <div className="-mx-1 my-1 h-px bg-border" />

      <MenuItem onClick={onHide}>
        <PiEyeClosed className="h-4 w-4" />
        Hide from map
      </MenuItem>
    </>
  );
};
